import { render } from "./nav-switch.vue?vue&type=template&id=a40906ba&scoped=true"
import script from "./nav-switch.vue?vue&type=script&lang=ts"
export * from "./nav-switch.vue?vue&type=script&lang=ts"

import "./nav-switch.vue?vue&type=style&index=0&id=a40906ba&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-a40906ba"

export default script